import React, { Component } from "react";
import "./Components/style.css";

class ContentPolicy extends Component {
  render() {
    return (
      <section className="contentWrapper">
        <h1>CONTENT POLICY FOR USERS</h1>
        <p>
          When submitting images through the Site, Services, and App, you must remove all personally identifying
          information (or information which could be used to identify an individual) regarding the person in the image
          and the relatives, employers, or household members of that person. This includes, but is not limited to, the
          following:
        </p>
        <ul>
          <li>
            <span>Names</span>
          </li>
          <li>
            <span>
              All geographical subdivisions smaller than a State or Province, including street address, city, county,
              precinct, zip code, and their equivalent geocodes, except for the initial three digits of a zip code, if
              according to the current publicly available data from the Bureau of the Census:
            </span>
            <ul>
              <li>
                <span>
                  The geographic unit formed by combining all zip codes with the same three initial digits contains more
                  than 20,000 people; and
                </span>
              </li>
              <li>
                <span>
                  The initial three digits of a zip code for all such geographic units containing 20,000 or fewer people
                  is changed to 000
                </span>
              </li>
            </ul>
          </li>
        </ul>
        <ul>
          <li>
            <span>Postal codes</span>
          </li>
          <li>
            <span>
              All elements (except year) for dates directly related to an individual, including birth date, admission
              date, patient encounter date, discharge date, date of death and exact age if over 89;
            </span>
          </li>
          <li>
            <span>Phone numbers, fax numbers, personal electronic mail addresses</span>
          </li>
          <li>
            <span>Social security or social insurance numbers, national identity number, or equivalent</span>
          </li>
          <li>
            <span>Medical record numbers</span>
          </li>
          <li>
            <span>Health card numbers, health plan beneficiary numbers, or Health Insurance Account numbers</span>
          </li>
          <li>
            <span>Account numbers</span>
          </li>
          <li>
            <span>Certificate/license numbers</span>
          </li>
          <li>
            <span>Vehicle identifiers and serial numbers, including license plate numbers</span>
          </li>
          <li>
            <span>Device identifiers and serial numbers</span>
          </li>
          <li>
            <span>Web Universal Resource Locators (URLs)</span>
          </li>
          <li>
            <span>Internet Protocol (IP) address numbers</span>
          </li>
          <li>
            <span>Biometric identifiers, including finger and voice prints</span>
          </li>
          <li>
            <span>Full face photographic images and any comparable images</span>
          </li>
          <li>
            <span>Photographic images of scars, tattoos, piercings etc. which would allow for an identification</span>
          </li>
          <li>
            <span>
              Any other unique identifying number, characteristic, or code (note this does not mean the unique code
              assigned by the investigator to code the data).
            </span>
          </li>
        </ul>
      </section>
    );
  }
}

export default ContentPolicy;



// WEBPACK FOOTER //
// ./src/scenes/Sections/ContentPolicy.js